import { createContext } from "react";

const ListAPIContext = createContext({
  departmentsQuery: null,
  departmentGroupsQuery: null,
  configurationQuery: null,
  activeRoundingSessionQuery: null,
  dispositionsQuery: null,
  userPreferencesQuery: null,
  analytics: null,
  showErrorToast: false,
  setShowErrorToast: null,
});

export default ListAPIContext;
